
/* ============================== src/components/Modals/EmployeeTasksModal.jsx ============================== */
// src/components/Modals/EmployeeTasksModal.jsx
import { useMemo } from "react";
import { ModalShell } from "../ModalShell";
import { fmtDMY } from "../../utils/date";
import { useEmployeeTasksReportQuery } from "../../api/queries/reports";

export function EmployeeTasksModal({
  db,
  employeeId,
  fromIso = null,
  toIso = null,
  openTask,
  onClose,
}) {
  const employee = useMemo(
    () => db.employees.find((e) => e.id === employeeId) || null,
    [db.employees, employeeId],
  );

  const withPeriod = !!(fromIso && toIso);

  const { data: reportData, isLoading } = useEmployeeTasksReportQuery(
    employeeId,
    fromIso || "",
    toIso || "",
    { enabled: withPeriod },
  );

  const rows = useMemo(() => {
    if (withPeriod) {
      return reportData ?? [];
    }
    // Без периода: все задачи сотрудника, остаток за всё время.
    return db.tasks
      .filter((t) => t.assigneeId === employeeId)
      .map((task) => {
        const plan = task.plannedHours == null ? null : task.plannedHours;
        const fact = (task.logs || []).reduce((s, l) => s + (l.hours || 0), 0);
        return {
          taskId: task.id,
          title: task.title,
          planInWindow: plan,
          factInWindow: fact,
        };
      });
  }, [withPeriod, reportData, db.tasks, employeeId]);

  const projectName = (projectId) =>
    db.projects.find((p) => p.id === projectId)?.name || "-";

  const handleTaskClick = (taskId) => {
    openTask(
      taskId,
      "form",
      null,
      null,
      null,
      null,
      null,
      null,
      employeeId,
      withPeriod ? { from: fromIso, to: toIso } : null,
    );
  };

  return (
    <ModalShell
      title={`Задачи сотрудника: ${employee ? `${employee.last} ${employee.first}` : "-"}`}
      onClose={onClose}
      width={880}
      showSave={false}
    >
      {isLoading ? (
        <div className="empty-note p-4">Загрузка…</div>
      ) : rows.length === 0 ? (
        <div className="empty-note p-4">Задач нет</div>
      ) : (
        <div className="w-full overflow-x-auto">
          <table className="tbl employee-tasks-table">
            <thead>
              <tr>
                <th className="text-left">Название задачи</th>
                <th className="text-left">Проект</th>
                <th className="text-center">Остаток плана</th>
                <th className="text-center">Срок</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => {
                const task = db.tasks.find((t) => t.id === row.taskId);
                const remaining =
                  row.planInWindow == null
                    ? null
                    : row.planInWindow - row.factInWindow;
                return (
                  <tr key={row.taskId}>
                    <td className="text-left">
                      <button
                        type="button"
                        className="link"
                        onClick={() => handleTaskClick(row.taskId)}
                        title="Открыть задачу"
                      >
                        {row.title}
                      </button>
                    </td>
                    <td className="text-left">
                      {task ? projectName(task.projectId) : "-"}
                    </td>
                    <td className="text-center">{remaining ?? "-"}</td>
                    <td className="text-center">
                      {task?.deadline ? fmtDMY(task.deadline) : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </ModalShell>
  );
}

export default EmployeeTasksModal;
